import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class Pan extends ActionCard {
    static typeId = "PAN";
    static cardName = "Pan !";
    static colorHex = "#CC2233";
    static countInDeck = ACTION_CARD_COUNTS.PAN;
    static description = "Abattez un mouton mis en joue.";

    isValidOn(slotIndex, gameState) {
        // Can only shoot at a targeted slot
        return gameState.lineOfFireSlots[slotIndex].isTargeted;
    }

    resolve(slotIndex, gameState) {
        gameState.resolveKills([slotIndex], this.typeId);
    }
}
